(function () {
  // Multiple sections can each request this file, producing duplicate <script> tags
  // on the same page. Only the first execution should actually run.
  if (window.__mbTextMarqueeLoaded) return;
  window.__mbTextMarqueeLoaded = true;

  function setup(root) {
    if (root.dataset.marqueeInit) return;
    root.dataset.marqueeInit = 'true';

    var track = root.querySelector('.text-marquee__track');
    var inner = root.querySelector('.text-marquee__inner');
    if (!track || !inner) {
      return;
    }

    var groups = Array.prototype.slice.call(inner.children).filter(function (el) {
      return el.classList.contains('text-marquee__group');
    });
    if (!groups.length) {
      return;
    }

    var template = groups[groups.length - 1];

    function ensureCoverage() {
      var setWidth = groups[0].getBoundingClientRect().width;
      if (!setWidth) {
        return;
      }

      var trackWidth = track.getBoundingClientRect().width;
      var needed = Math.ceil(trackWidth / setWidth) + 1;

      while (groups.length < needed) {
        var clone = template.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        inner.appendChild(clone);
        groups.push(clone);
      }

      root.style.setProperty('--marquee-shift', '-' + setWidth + 'px');

      // Restart the animation so it re-reads --marquee-shift: browsers don't
      // always re-resolve a keyframe's custom property on an already-running animation.
      inner.style.animation = 'none';
      void inner.offsetWidth;
      inner.style.animation = '';
    }

    ensureCoverage();

    if (window.ResizeObserver) {
      new ResizeObserver(ensureCoverage).observe(track);
    } else {
      window.addEventListener('resize', ensureCoverage);
    }
  }

  function init(context) {
    var roots = (context || document).querySelectorAll('.text-marquee');
    roots.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
